import JSCookie from 'js-cookie';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import COOKIES from '~/constants/cookies';
import { useIsNative } from '~/context/common/DeviceContext';
import { getAssociatedVdpEventId } from '~/selectors';

const isModifiedClick = ({ ctrlKey, metaKey }) => {
  if (navigator.platform.indexOf('Mac') === 0) return metaKey;

  return ctrlKey;
};

export default function useOnClick() {
  const isNative = useIsNative();
  const associatedVdpEventId = useSelector(getAssociatedVdpEventId);

  return useCallback(
    (ev: React.MouseEvent<HTMLAnchorElement>) => {
      ev.preventDefault();

      JSCookie.set(COOKIES.correspondingEventId, associatedVdpEventId);

      if (!isNative) {
        window.open(
          ev.currentTarget.href,
          isModifiedClick(ev) ? '_blank' : '_self'
        );
      }
    },
    [associatedVdpEventId, isNative]
  );
}
